var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"help-icon"},[_c('a',{staticClass:"helper-icon",attrs:{"aria-label":"Help","tabindex":"0"},on:{"click":function($event){$event.preventDefault();return _vm.showModal.apply(null, arguments)}}},[_vm._t("default"),_c('i',{staticClass:"fas fa-info-circle",attrs:{"aria-hidden":"true"}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }